import React, { useState } from 'react';
import Navbar from '../common/Navbar';
import Sidebar from '../common/Sidebar';

const Layout = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div style={styles.container}>
      <Navbar onMenuToggle={toggleMobileMenu} />
      <div style={styles.content}>
        <Sidebar isMobileOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
        <main style={styles.main}>
          {children}
        </main>
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: 'var(--light)',
  },
  content: {
    display: 'flex',
    minHeight: 'calc(100vh - 80px)',
    position: 'relative',
  },
  main: {
    flex: 1,
    padding: '2rem',
    overflow: 'auto',
    width: '100%',
  },
};

// Responsive styles
const mediaQuery = window.matchMedia('(max-width: 768px)');
if (mediaQuery.matches) {
  styles.main.padding = '1rem';
}

export default Layout;





